function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShareMp4 = function SvgShareMp4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0 0 36.985 0Z",
    style: {
      fill: "#e9e9e0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 28a1 1 0 0 1-1-1V13a1.001 1.001 0 0 1 1.538-.844l11 7a1.003 1.003 0 0 1-.001 1.688l-11 7c-.163.103-.35.156-.537.156Zm1-13.179v10.357L33.637 20 25.5 14.821Z",
    style: {
      fill: "#c8bdb8",
      fillRule: "nonzero"
    },
    transform: "translate(5.082 19.095) scale(.80301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 35c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15Zm0-28c-7.168 0-13 5.832-13 13s5.832 13 13 13 13-5.832 13-13-5.832-13-13-13Z",
    style: {
      fill: "#c8bdb8",
      fillRule: "nonzero"
    },
    transform: "translate(5.082 19.095) scale(.80301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5.151V12h11.849L37.5.151Z",
    style: {
      fill: "#d9d7ca",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff5364"
    },
    d: "M3.759 1.929h31.026v12.266H3.759z",
    transform: "matrix(1.04306 0 0 1.01149 -1.268 2.604)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.791 16.821H6.5v5.037l-3.709-5.037Z",
    style: {
      fill: "#ff3549"
    },
    transform: "translate(-.17 -.052) scale(1.01149)"
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fontFamily: "'ArialMT','Arial',sans-serif",
      fontSize: "9.336px",
      fill: "#fff"
    },
    transform: "translate(8.587 14.37) scale(1.08068)"
  }, "MP4"));
};
export default SvgShareMp4;